<!-- 
    定时任务开关以及时间选择
    jay 2020-02-24
 -->
<template>
  <div>
    <div class="choose-switch">
      <van-cell
        :title="switchFlag ? $t('recharge.open') : $t('recharge.close')"
      >
        <van-switch v-model="switchFlag" slot="right-icon" size="24" />
      </van-cell>
      <p>
        {{ $t("recharge.openTips") }}
      </p>
    </div>
    <div class="choose-date">
      <van-cell
        :title="$t('recharge.dateSelection')"
        is-link
        :value="
          thisDay == 0
            ? $t('recharge.lastDayOfEveryMonth')
            : language == 'en'
            ? thisDay +
              (thisDay == 1
                ? 'st'
                : thisDay == 2
                ? 'nd'
                : thisDay == 3
                ? 'rd'
                : 'th') +
              $t('recharge.everyMonth')
            : $t('recharge.everyMonth') + thisDay + $t('common.days')
        "
        @click="dateFlag = true"
      />
    </div>

    <van-popup
      v-model="dateFlag"
      get-container="body"
      class="date-pop"
      position="bottom"
    >
      <div class="pop-handle">
        <a class="cancle" @click="dateFlag = false">
          {{ $t("common.cancel") }}
        </a>
        <a @click="dataisOk">{{ $t("common.confirm") }}</a>
      </div>
      <ul class="pop-list">
        <li
          :class="{ active: curData == item }"
          v-for="(item, index) in 28"
          :key="index"
          @click="chooseDate(item)"
        >
          <a>{{ item }}</a>
        </li>
        <li class="placeholder-li"></li>
        <li class="placeholder-li"></li>
        <li class="placeholder-li"></li>
        <li class="placeholder-li"></li>
        <li class="placeholder-li"></li>
        <li class="placeholder-li"></li>
        <li class="placeholder-li"></li>
        <li
          class="last-day"
          :class="{ active: curData == 0 }"
          @click="chooseDate(0)"
        >
          <a>{{ $t("recharge.lastDayOfEveryMonth") }}</a>
        </li>
      </ul>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    taskInfo: {
      //定时任务信息
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {
      switchFlag: true,
      dateFlag: false,
      thisDay: 1,
      curData: 1
    };
  },
  created() {},
  mounted() {
    if (this.taskInfo.timer_id) {
      this.thisDay = this.taskInfo.day;
      this.curData = this.taskInfo.day;
      this.switchFlag = this.taskInfo.state == 1 ? true : false;
    }
    console.log("taskInfo", this.taskInfo);
  },
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    dataisOk() {
      //确认选择了日期
      let vm = this;
      vm.thisDay = vm.curData;
      vm.dateFlag = false;
      let obj = {};
      obj.thisDay = vm.thisDay;
      obj.switchFlag = vm.switchFlag;
      vm.$emit("getTaskTiming", obj);
    },
    chooseDate(value) {
      //选择日期
      let vm = this;
      vm.curData = value;
    }
  },
  watch: {
    switchFlag() {
      let vm = this;
      let obj = {};
      obj.thisDay = vm.thisDay;
      obj.switchFlag = vm.switchFlag;
      vm.$emit("getTaskTiming", obj);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.van-cell:not(:last-child)::after {
  display: none;
}
/deep/.van-cell {
  .van-cell__title,
  .van-cell__value {
    font-size: 16px;
  }
}
.choose-switch {
  border-bottom: 1.1px solid #e4e4e4;
  padding: 10px 0;
  p {
    padding: 0 16px;
    font-size: 11px;
    color: #9b9b9b;
    line-height: 16px;
    text-align: justify;
  }
  .van-switch--on {
    background-color: #2042ab;
  }
}
.pop-handle {
  height: 40px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1.1px solid #eeeeee;
  a {
    font-size: 15px;
    color: #fe7800;
    &.cancle {
      color: #9b9b9b;
    }
  }
}
.pop-list {
  padding: 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  li {
    width: 40px;
    height: 40px;
    border-radius: 40px;
    font-size: 16px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:nth-child(7n) {
      margin-right: 0;
    }
    a {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.active {
      a {
        background: #2042ab;
        color: #fff;
      }
    }
    &.last-day {
      width: 100%;
      a {
        display: initial;
        width: initial;
        height: initial;
        padding: 8px 14px;
        border-radius: 5px;
        border: 1.1px solid #eeeeee;
      }
    }
    &.placeholder-li {
      border: 0;
      margin: 0;
      padding: 0;
      height: 0px;
    }
  }
}
</style>
